module.exports = __webpack_public_path__ + "public/images/Illustration_Teacher_200x200-Color.ee809317ebba04f32c7c2caa3e6f51e2.png";